import styled from "styled-components"
import { device } from "utils/breakpoints"

export const SelectContainer = styled.div`
  width: 100%;
  z-index: 5;
  margin: 10px 0;
  @media ${device.desktop} {
    margin: 0;
    width: auto !important;
  }
  .css-1hwfws3 {
    padding: 0;
  }

  .basic__control {
    box-shadow: 0;
    background-color: white;
    /* border-radius: state.isFocused ? "3px 3px 0 0" : "3px", */
    border: none;
    outline: none !important;
    height: 50px;
    cursor: pointer;
    border-radius: 2px;
    padding-left: 20px;
    opacity: 1 !important;
    border-color: none !important;
    white-space: pre;
    @media ${device.desktop} {
      height: 80px;
      padding-left: 30px;
      width: 500px;
    }
  }
  .basic__indicator-separator {
    display: none;
  }
  .basic__menu {
    margin-top: 0;
    background: white;
    opacity: 1 !important;
    box-shadow: 0 10px 35px 0 rgba(0, 0, 0, 0.35);
  }
  .basic__menu-list {
    padding-top: 0;
    padding-bottom: 0;
    background: white;
    opacity: 1 !important;
  }

  .basic__option {
    color: #5c6370;
    font-weight: 500;
    line-height: 16px;
    font-size: 16px;
    z-index: 5;
    background: white;
    letter-spacing: 0;
    padding: 20px;
    padding-left: 20px;

    @media ${device.desktop} {
      font-size: 18px;
      padding: 22px;
      opacity: 1 !important;
      padding-left: 30px;
    }

    :hover {
      background: #2a3449;
      color: white;
    }
  }
  .basic__option--is-focused {
    background-color: #eee;
    transition: 90ms;

    cursor: pointer;
  }

  .basic__option--is-selected {
    background-color: #eee;

    /* font-weight: 600; */
  }
`

export const ArrowContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 100%;
  border-left: 1px solid #dce0e7;
  @media ${device.desktop} {
    width: 80px;
  }

  svg {
    width: 16px;
    transform: rotateX(${props => (props.open ? "180deg" : "0")});
    transition: ${props => (props.open ? "300ms" : "300ms")};

    @media ${device.desktop} {
      width: 19px;
    }
    path {
      stroke: #f17071;
    }
  }
`

export const SingleValueContainer = styled.div`
  position: absolute !important;
  font-size: 16px;

  @media ${device.desktop} {
    position: relative !important;
  }

  span {
    color: #5c6370;
  }

  span.view {
    color: #2a3449;
    margin-right: 3px;
    font-weight: 600;
  }

  @media ${device.desktop} {
    font-size: 18px;
  }
`

export const Placeholder = styled(SingleValueContainer)`
  background: red;
`
